var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel-resize",class:{ 'panel-resize--right': _vm.rightAligned }})
}
var staticRenderFns = []

export { render, staticRenderFns }